<template>
  <div v-wechat-title='$route.query.deptname'>
    <md-field v-if="remoteData.length === 0">
      <md-skeleton avatar title :loading="remoteDataLoading">
        <md-cell-item>无数据</md-cell-item>
        <md-cell-item v-if="this.remoteError">{{this.remoteError}}</md-cell-item>
      </md-skeleton>
    </md-field>
    <template v-else>
      <md-field>
        <md-cell-item :title="remoteData.doctor.name" :brief="remoteData.doctor.title" addon="">
          <span class="holder" slot="left">{{remoteData.doctor.name[0]}}</span>
        </md-cell-item>
        <md-detail-item title="科室" :content="remoteData.department.name"/>
        <md-detail-item title="就诊日期" :content="remoteData.date + '  (' + remoteData.week + ')'"/>
        <md-detail-item title="就诊时间" :content="remoteData.timeBegin + ' - ' + remoteData.timeEnd"/>

        <md-tabs @change="onPatientTabsChange" v-model="patientTab" >
          <md-tab-pane class="content" name='p1' label="就诊人">
            <md-radio-box v-for="item of remoteData.patientList" :key="item.id" v-model="patient.id" :name="item.id">
              {{item.name}}
            </md-radio-box>
            <br v-if="remoteData && remoteData.patientList && remoteData.patientList.length !== 0" />
            <md-button type="warning" plain @click='onNewPatientClick' size='small' inline>新增就诊人</md-button>
          </md-tab-pane>
          <md-tab-pane class="content" name='p2' label="新增">
            <md-input-item :solid="solidValue" title="*姓名" placeholder="就诊人姓名" v-model="patient.name" type="text" @blur="onBlur" clearable/>
            <md-field-item :solid="solidValue" title="*证件类型">
              <md-radio :name="credentialTypeOptions[0].value" v-model="patient.credentialType" :label="credentialTypeOptions[0].text" />
              <md-radio :name="credentialTypeOptions[1].value" v-model="patient.credentialType" :label="credentialTypeOptions[1].text" />
              <md-radio :name="credentialTypeOptions[2].value" v-model="patient.credentialType" :label="credentialTypeOptions[2].text" />
            </md-field-item>
            <md-input-item :solid="solidValue" title="*证件号" placeholder="就诊人证件号"
               v-model="patient.credentialNo" type="text" @blur="onBlurCredentialNo" clearable v-show="!isParentNameShow"/>
            <md-input-item :solid="solidValue" title="*母亲姓名" placeholder="就诊人母亲的姓名" v-model="patient.parentsName" type="text" @blur="onBlur" clearable v-show="isParentNameShow"/>

            <md-field-item :solid="solidValue" title="*生日" align="left" :content="patient.birthday" @click.native="isDatePickerShow = true" arrow="arrow-right">
            </md-field-item>

            <md-field-item :solid="solidValue" title="*性别">
              <md-radio name="男" v-model="patient.sex" label="男" inline />
              <md-radio name="女" v-model="patient.sex" label="女" inline />
            </md-field-item>
            <md-input-item :solid="solidValue" title="*联系手机" placeholder="能联系到就诊人的手机号码" v-model="patient.phone" type="phone" @blur="onBlur" clearable/>
          </md-tab-pane>
        </md-tabs>
        <md-detail-item>
          <md-button type="primary" size="small" inline @click="onOrderSubmit" :loading="submitLoading">提&nbsp;交</md-button>
        </md-detail-item>
      </md-field>

      <md-date-picker
        ref="datePicker"
        v-model="isDatePickerShow"
        type="custom"
        title="选择日期"
        large-radius
        :custom-types="['yyyy', 'MM','dd']"
        :default-date="currentDate"
        :min-date="minDate"
        :max-date="maxDate"
        @change="onDatePickerChange"
        @confirm="onDatePickerConfirm"
      ></md-date-picker>

    </template>
  </div>
</template>

<script>
import { orderCreate, orderPrepare } from '@api/daOrder'
import { isEmpty, formatDate } from '@utils/func'
import idCode from '@utils/idCode'
import { isWeixin, verPhone } from "@utils"
import { Dialog, Toast, Field, FieldItem, DetailItem, CellItem, Button, RadioBox, Radio, Tabs, TabPane, InputItem, Selector, Skeleton, DatePicker } from 'mand-mobile'

export default {
  name: 'OrderCreate',
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [DetailItem.name]: DetailItem,
    [CellItem.name]: CellItem,
    [Button.name]: Button,
    [RadioBox.name]: RadioBox,
    [Radio.name]: Radio,
    [Selector.name]: Selector,
    [Skeleton.name]: Skeleton,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      isDatePickerShow: false,
      isParentNameShow: false,
      currentDate: new Date('2010-01-01'),
      minDate: new Date('1920-01-01'),
      maxDate: new Date(),
      patientTab: 'p1',
      remoteData: [],
      remoteDataLoading: false,
      remoteError: null,
      submitLoading: false,
      solidValue: true,
      patient: {
        id: null, name: '', birthday: null, sex: '', credentialType: 'id_card', credentialNo: '', phone: '', parentsName: ''
      },
      // TODO 从后台获取列表
      credentialTypeOptions: [
        { text: '身份证', value: 'id_card' },
        { text: '未办理身份证', value: 'none' },
        { text: '其它证件', value: 'other' }
      ]
    }
  },
  computed: {
    /*credentialTypeName () {
      for (const index in this.credentialTypeOptions) {
        if (this.credentialTypeOptions[index].value === this.patient.credentialType) {
          return this.credentialTypeOptions[index].text
        }
      }
      return this.patient.credentialType
    }*/
  },
  watch: {
    deep: false,
    'patient.id': {
      handler(val, oldVal) {
        if (isEmpty(val)) {
          return
        }
        if (this.remoteData.length === 0) {
          return
        }
        for (const p of this.remoteData.patientList) {
          if (p.id === val) {
            Toast({
              content: '证件号：' + p.credentialNo,
              position: 'bottom'
            })
            return
          }
        }
      }
    },
    'patient.credentialType': {
      handler(val, oldVal) {
        if (isEmpty(val)) {
          return
        }
        if (val === 'none') {
          this.isParentNameShow = true
          this.patient.credentialNo = ''
        } else {
          this.isParentNameShow = false
          this.patient.parentsName = ''
        }
      }
    }
  },
  created () {
    this.remoteDataLoading = true
    this.remoteError = null
    this.remoteData = []
    orderPrepare(this.$route.query.dsid, this.$route.query.tridx).then(res => {
      this.remoteDataLoading = false
      console.log('orderPrepare res:', res)
      if (res.data && res.status === 200) {
        this.remoteData = res.data
        this.remoteError = ''
      } else {
        this.remoteError = res.msg
      }
    }).catch(err => {
      this.remoteDataLoading = false
      console.log('orderPrepare err:', err)
      // TODO 刷新订单或。。。
      Toast.info('错误：' + err)
      this.remoteError = err
    })
  },
  methods: {
    onNewPatientClick () {
      this.patient.id = null
      this.patientTab = 'p2'
    },
    onDatePickerChange(columnIndex, itemIndex, value) {
      //this.patient.birthday = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
      //console.log(this.patient.birthday)
    },
    onDatePickerConfirm(columnsValue) {
      this.patient.birthday = this.$refs.datePicker.getFormatDate('yyyy-MM-dd')
      console.log(columnsValue)
    },
    onBlur() {
      window.scrollTo(0, document.documentElement.scrollTop || document.body.scrollTop)
    },
    onBlurCredentialNo() {
      this.onBlur()
      // 验证身份证
      if (this.patient.credentialType === 'id_card') {
        const obj = idCode.createNew(this.patient.credentialNo)
        if (!obj.isCheck()) {
          Dialog.alert({
            title: '错误',
            content: '身份证填写错误'
          })
          return
        }
        const sex = obj.getGender()
        this.patient.sex = sex
        this.patient.birthday = obj.getYears() + '-' + obj.getMonth() + '-' + obj.getDay()
        this.currentDate = new Date(this.patient.birthday)
      }
    },
    onOrderSubmit () {
      if (this.patientTab === 'p1') {
        if (this.patient.id == null) {
          Toast({
            content: '请选择就诊人',
            position: 'top'
          })
          return
        }
      } else {
        if (isEmpty(this.patient.name)) {
          Toast.info('请填写就诊人姓名')
          return
        }
        if (this.patient.name.length < 2) {
          Toast.info('就诊人姓名长度不够')
          return
        }
        if (this.patient.credentialType === 'id_card') {
          if (!idCode.createNew(this.patient.credentialNo).isCheck()) {
            Toast.info('二代身份证号填写错误')
            return
          }
        } else if (this.patient.credentialType === 'other') {
          if (isEmpty(this.patient.credentialNo) || this.patient.credentialNo.length < 6) {
            Toast.info('证件号错误，长度至少6位')
            return
          }
        }
        if (isEmpty(this.patient.sex)) {
          Toast.info('请选择就诊人性别')
          return
        }
        if (isEmpty(this.patient.birthday)) {
          Toast.info('请设置就诊人生日')
          return
        }
        if (this.patient.credentialType === 'none') {
          if (isEmpty(this.patient.parentsName)) {
            Toast.info('请输入就诊人母亲的姓名')
            return
          }
          // 没有身份证的就诊人，使用其生日填充
          this.patient.credentialNo = formatDate(new Date(this.patient.birthday), 'yyyyMMdd')
        }
        if (isEmpty(this.patient.phone)) {
          Toast.info('请设置就诊人联系手机')
          return
        }
        if (!verPhone(this.patient.phone)) {
          Toast.info('就诊人联系手机格式不正确')
          return
        }
      }

      let orderFrom = 'H5'
      if (isWeixin()) {
        orderFrom = 'H5WX'
      }
      this.submitLoading = true
      orderCreate(this.$route.query.dsid, this.$route.query.tridx, orderFrom, this.patient).then(res => {
        this.submitLoading = false
        console.log('orderCreate.res:', res)
        if (res.data && res.data.orderId && res.status === 200) {
          this.$router.replace({
            path: 'order-view',
            query: {
              orderId: res.data.orderId
            }
          })
        } else {
          Dialog.failed({
            title: '失败',
            content: res.msg,
            confirmText: '确定',
            onConfirm: () => {
              this.$router.replace({
                path: 'department',
                query: {
                  id: this.$route.query.deptid,
                  name: this.$route.query.deptname
                }
              })
            }
          })
          if (this.patient.id) {
            this.patientTab = 'p1'
          }
        }
      }).catch(err => {
        this.submitLoading = false
        console.log('orderCreate.err:', err)
        Dialog.failed({
          title: '失败',
          confirmText: '知道了',
          content: (err.msg || err)
        })
        if (this.patient.id) {
          this.patientTab = 'p1'
        }
      })
    },
    onPatientTabsChange (tab) {
      // this.patientTab = tab.name
      if (tab.name === 'p2') {
        this.patient.id = null
      }
    }
  }
}
</script>

<style scoped>
  .md-check-base-box {
    font-size:0.3rem;
    margin: 0 0.15rem;
  }
</style>
